'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var debounce = require('../debounce-d1f5a67b.js');
var useOnKeyboardPress = require('../useOnKeyboardPress-d580d97f.js');
var useScrollLock = require('../useScrollLock-3e2e9f39.js');
var useOnEscapePress = require('../useOnEscapePress-9ee80763.js');
var useOutsideClick = require('../useOutsideClick-531afbb5.js');
var React = require('react');
var scroll = require('../scroll-747d76d9.js');
var useExpiryTime = require('../useExpiryTime-b8edb931.js');
require('body-scroll-lock');
require('../tslib.es6-130a177d.js');
require('styled-components');

var useUnmount = function (callback, dependency) {
    var callbackRef = React.useRef(callback);
    callbackRef.current = callback;
    var deps = dependency || [];
    React.useEffect(function () { return function () { return callbackRef.current(); }; }, deps);
};

var DEFAULT_OPTIONS = {
    root: null,
    rootMargin: '0px',
    threshold: 0,
};
function useInView(_a) {
    var containerRef = _a.containerRef, _b = _a.options, options = _b === void 0 ? DEFAULT_OPTIONS : _b, _c = _a.triggerOnce, triggerOnce = _c === void 0 ? true : _c, onVisibleCallback = _a.onVisibleCallback, dependency = _a.dependency;
    var _d = React.useState(false), isVisible = _d[0], setIsVisible = _d[1];
    var _e = React.useState(false), onVisibleCallbackTriggered = _e[0], setOnVisibleCallbackTriggered = _e[1];
    useUnmount(React.useCallback(function () {
        setIsVisible(false);
        setOnVisibleCallbackTriggered(false);
    }, []), [dependency]);
    React.useEffect(function () {
        setOnVisibleCallbackTriggered(false);
    }, [dependency]);
    var callbackFn = React.useCallback(function (entries) {
        var entry = entries[0];
        setIsVisible(entry.isIntersecting);
    }, []);
    React.useEffect(function () {
        var current = containerRef.current;
        var observer = new IntersectionObserver(callbackFn, options);
        if (current) {
            observer.observe(current);
            if (isVisible && triggerOnce) {
                observer.unobserve(current);
            }
        }
        return function () {
            if (current) {
                observer.unobserve(current);
            }
        };
    }, [callbackFn, containerRef, isVisible, options, triggerOnce]);
    React.useEffect(function () {
        if (isVisible && onVisibleCallback && !onVisibleCallbackTriggered) {
            onVisibleCallback();
            setOnVisibleCallbackTriggered(true);
        }
    }, [isVisible, onVisibleCallback, onVisibleCallbackTriggered]);
    return isVisible;
}

var clubProductUrl = function (productName, productId, campaignUrlKey) {
    if (campaignUrlKey === void 0) { campaignUrlKey = ''; }
    var replaced = {
        ç: 'c',
        á: 'a',
        ã: 'a',
        ó: 'o',
        õ: 'o',
        ô: 'o',
        é: 'e',
        ê: 'e',
        í: 'i',
        ú: 'u',
        â: 'a',
        à: 'a',
        Ã: 'A',
        Á: 'A',
        Â: 'A',
        À: 'A',
        Ç: 'C',
        É: 'E',
        Ê: 'E',
        Í: 'I',
        Õ: 'O',
        Ó: 'O',
        Ô: 'O',
        Ú: 'U',
        ä: 'ae',
        ö: 'oe',
        ü: 'ue',
        Ä: 'Ae',
        Ö: 'Oe',
        Ü: 'Ue',
        ß: 'ss',
    };
    var nameAsUrl = productName.replace(' ', '-');
    Object.keys(replaced).forEach(function (key) {
        var regex = new RegExp(key, 'g');
        nameAsUrl = nameAsUrl.replace(regex, replaced[key]);
    });
    nameAsUrl = nameAsUrl
        .toLowerCase()
        .replace(/[^\da-zA-Z-]/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');
    var campaign = campaignUrlKey ? "c=" + campaignUrlKey + "&" : '';
    return encodeURIComponent(nameAsUrl) + "-" + productId + ".html?" + campaign + "sizeSelected=";
};

exports.debounce = debounce.debounce;
Object.defineProperty(exports, 'SupportedKey', {
    enumerable: true,
    get: function () {
        return useOnKeyboardPress.SupportedKey;
    }
});
exports.useOnKeyboardPress = useOnKeyboardPress.useOnKeyboardPress;
exports.useScrollLock = useScrollLock.useScrollLock;
exports.useOnEscapePress = useOnEscapePress.useOnEscapePress;
exports.useOutsideClick = useOutsideClick.useOutsideClick;
exports.scroll = scroll.scroll;
exports.useExpiryTime = useExpiryTime.useExpiryTime;
exports.clubProductUrl = clubProductUrl;
exports.useInView = useInView;
exports.useUnmount = useUnmount;
//# sourceMappingURL=index.js.map
